import React, { useState } from "react";
import TemplateArticleHelp from "../TemplateArticleHelp/TemplateArticleHelp";
import styles from "./ContactManagement.module.css";
import { ReactComponent as ArrowDownBold } from "../../../assets/arrowDownBold.svg";
// import { ReactComponent as BlackWarningIcon } from "../../../assets/BlackWarningIcon.svg";
import { ReactComponent as ConectionsGrayIcon } from "../../../assets/ConectionsGrayIcon.svg";
// import { ReactComponent as HouseIcon } from "../../../assets/HouseIcon.svg";
// import { ReactComponent as RocketIcon } from "../../../assets/rocketIcon.svg";
// import { ReactComponent as ArrowRightText } from "../../../assets/arrowRightText.svg";
import { ReactComponent as FilterIconBars } from "../../../assets/S3/filterIconBars.svg";
import { ReactComponent as ContactsGreenIcon } from "../../../assets/ContactsGreenIcon.svg";
import { ReactComponent as DownloadButtonIcon } from "../../../assets/DownloadButtonIcon.svg";
import { useTranslation } from "react-i18next";

const ContactManagement = ({setSelectedCategory}) => {
  const { t } = useTranslation("helpPage");

  const [activeArticles, setActiveArticles] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
  });

  const handleClick = (index) => {
    setActiveArticles((prevState) => ({
      ...prevState,
      [index]: !prevState[index], 
    }));
  };

  return (
    <div>
      <TemplateArticleHelp
        title={t('contactManagement')}
        description={t('contactManagementDesc')}
        Icon={ContactsGreenIcon}
        setSelectedCategory={setSelectedCategory}
      >
        <div className={styles.articlesContent}>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(1)} 
            >
              {t('contactRegistrationControl')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[1] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
              <ul>
                <li>
                  {t('addContacts')}
                </li>

                <li>
                  {t('editInformation')}
                </li>
                <li>
                  {t('facturagptDetectsDuplicates')}
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(2)} 
            >
              {t('importContacts')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[2] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
             {t('importContactsDesc')}
              <ul>
                <li>
                 {t('importcontactsList1')}
                </li>
              </ul>
              <div style={{ margin: "20px auto", width: "fit-content" }}>
                <DownloadButtonIcon />
              </div>
              <ul>
                <li>
                 {t('importcontactsList2')}
                </li>
              </ul>
              <div style={{ margin: "20px auto", width: "fit-content" }}>
                <ConectionsGrayIcon />
              </div>
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(3)} 
            >
              {t('settingsParameters')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[3] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
              {t('configurationOptions')}
              <ul>
                <li>
                {t('configurationOptionsList1')}
                </li>
                <li>
                {t('configurationOptionsList2')}
                </li>
                <li>
                {t('configurationOptionsList3')}
                </li>
              </ul>
              <br />
              <br />
              {t('configurationOptionsList4')}
            </div>
          </div>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(3)} 
            >
              {t('exportContacts')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[3] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
              {t('exportYourList')}
              <ul>
                <li>{t('exportToSpreadsheet')}</li>
              </ul>
              <div
                style={{
                  margin: "20px auto",
                  width: "fit-content",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {t('contactManagementExport')} <DownloadButtonIcon /> &gt; {t('export')}
              </div>
              <div
                style={{
                  margin: "20px auto",
                  width: "fit-content",
                  color: "#B4B1B1",
                }}
              >
                {t('orFrom')}
              </div>
              <div style={{ margin: "20px auto", width: "fit-content" }}>
                {t('settingDataControl')} 
              </div>
              <ul>
                <li>
                  {t('automateYourContactList')}
                </li>
              </ul>
              <div style={{ margin: "20px auto", width: "fit-content" }}>
                <ConectionsGrayIcon />
              </div>
              <ul>
                <li>
                  {t('advancedContact')}
                </li>
              </ul>
              <div style={{ margin: "20px auto", width: "fit-content" }}>
                <FilterIconBars />
              </div>
            </div>
          </div>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(4)} 
            >
              {t('historyTraceability')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[4] ? "auto" : "0px", 
              }}
            >
          {t('historyTraceabilityDesc')}
              <ul>
                <li>{t('historyTraceabilityList1')}</li>
                <li>{t('historyTraceabilityList2')}</li>
                <li>{t('historyTraceabilityList3')}</li>
                <li>{t('historyTraceabilityList4')}</li>
              </ul>
              <br />
              <br />
              {t('historyTraceabilityList5')}
             
            </div>
          </div>
        </div>
      </TemplateArticleHelp>
    </div>
  );
};

export default ContactManagement;
